<template>
	<header
		:class="[
			'header',
			{
				header_mobile: isHeaderMobile || isScrolable,
				header_scrolled: isScrolled,
				header_transparent: isDarkHeaderRoute,
			},
		]"
	>
		<div class="header__inner _cnt">
			<router-link to="/" class="header__logo _ibg-contain">
				<img src="@/assets/images/icons/logo.svg" />
			</router-link>
			<nav class="header__nav nav" :class="{ 'menu-open': menuVisible }">
				<ul class="nav__list">
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active:
									$route.name === 'ProductListPage' &&
									$route.params.itemType === 'all' &&
									!$route.query.filter_date,
							}"
							:to="{
								name: 'ProductListPage',
								params: { itemType: 'all' },
							}"
						>
							{{ $t('Shop') }}
						</router-link>
					</li>
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active:
									$route.name === 'ProductListPage' &&
									$route.params.itemType === 'all' &&
									$route.query.filter_date === '1',
							}"
							:to="{
								name: 'ProductListPage',
								params: { itemType: 'all' },
								query: { filter_date: '1' },
							}"
						>
							{{ $t('New skins') }}
						</router-link>
					</li>
				</ul>
			</nav>
			<div class="header__options" data-da=".header__nav,767.98">
				<div
					v-show="currencyOptions && currencyOptions.length > 1"
					class="header__options-wrapper select-wrapper"
				>
					<select
						class="_select"
						v-model="selectedCurrency"
						@change="handleCurrencyChange"
					>
						<option
							v-for="opt in currencyOptions"
							:key="opt.id"
							:value="opt.id"
						>
							{{ opt.text }}
						</option>
					</select>
				</div>
				<div
					v-show="languages && languages.length > 1"
					class="header__options-wrapper select-wrapper"
				>
					<select
						class="_select"
						v-model="selectedLanguage"
						@change="handleLanguageChange"
					>
						<option
							v-for="opt in languageOptions"
							:key="opt.id"
							:value="opt.id"
						>
							{{ opt.text }}
						</option>
					</select>
				</div>
			</div>
			<div v-show="isAuth" class="header__user-menu user-menu">
				<router-link
					v-show="isAuth"
					to="/profile/account-balance"
					class="user-menu__wallet wallet"
					:class="{
						wallet_active: $route.path === '/profile/account-balance',
					}"
					data-da=".header__nav,619.98"
				>
					<div class="wallet__numbers">
						<div class="wallet__top">
							<div class="wallet__coin-number">
								{{ (userBalance).toFixed(2) }}
							</div>
							<div class="wallet__coin-number">
								{{ currencySymbol }}
							</div>
							<!--<div class="wallet__coin-icon _ibg-contain">
								<img src="@/assets/images/icons/coin.svg" />
							</div>-->
						</div>
						<!--<div class="wallet__bottom">
							<div class="wallet__real-number">
								{{ (userBalance * this.currency.value).toFixed(2) }}
							</div>
							<div class="wallet__real-symbol">
								{{ currencySymbol }}
							</div>
						</div>-->
					</div>
					<button class="wallet__button _button-white">
						{{ $t('Top up') }}
					</button>
				</router-link>
				<div class="user-menu__actions">
					<button class="user-menu__cart" @click="$emit('openCartModal')">
						<div class="user-menu__cart-icon _svg-icon">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M2.08106 17.4037C1.03504 13.2196 0.512023 11.1287 1.61047 9.72185C2.70892 8.31496 4.86558 8.31496 9.17769 8.31496H14.8223C19.1356 8.31496 21.2911 8.31496 22.3895 9.72185C23.488 11.1287 22.965 13.2208 21.9189 17.4037C21.2533 20.0651 20.9217 21.3951 19.9293 22.1705C18.9369 22.9447 17.5654 22.9447 14.8223 22.9447H9.17769C6.43462 22.9447 5.06308 22.9447 4.0707 22.1705C3.07832 21.3951 2.74549 20.0651 2.08106 17.4037Z"
									stroke-width="2"
								/>
								<path
									d="M21.1446 8.92452L20.279 5.74865C19.9449 4.52342 19.7779 3.91141 19.4353 3.44935C19.0937 2.9903 18.6298 2.63668 18.0967 2.42893C17.5603 2.21924 16.9263 2.21924 15.6584 2.21924M2.85742 8.92452L3.72301 5.74865C4.05706 4.52342 4.22408 3.91141 4.56666 3.44935C4.90823 2.9903 5.37213 2.63668 5.90528 2.42893C6.4417 2.21924 7.07565 2.21924 8.34356 2.21924"
									stroke-width="2"
								/>
								<path
									d="M8.34375 2.21914C8.34375 1.89581 8.4722 1.58571 8.70083 1.35708C8.92946 1.12844 9.23956 1 9.56289 1H14.4395C14.7628 1 15.0729 1.12844 15.3015 1.35708C15.5302 1.58571 15.6586 1.89581 15.6586 2.21914C15.6586 2.54248 15.5302 2.85257 15.3015 3.08121C15.0729 3.30984 14.7628 3.43828 14.4395 3.43828H9.56289C9.23956 3.43828 8.92946 3.30984 8.70083 3.08121C8.4722 2.85257 8.34375 2.54248 8.34375 2.21914Z"
									stroke-width="2"
								/>
								<path
									d="M7.12305 13.1914V18.068M16.8762 13.1914V18.068M11.9996 13.1914V18.068"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
						<p
							v-show="cartContents.length"
							class="user-menu__cart-amount _text-primary"
						>
							{{ cartContents.length }}
						</p>
					</button>
					<router-link
						to="/profile/personal-information"
						class="user-menu__profile"
					>
						<div class="user-menu__profile-icon _svg-icon">
							<svg
								width="15"
								height="16"
								viewBox="0 0 15 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M7.15375 9.47229C5.60721 9.47147 4.09746 9.94391 2.82725 10.8262C1.55705 11.7084 0.587224 12.9582 0.0480348 14.4077C-0.143965 14.9203 0.265749 15.4277 0.812606 15.4277H13.4932C14.04 15.4277 14.448 14.9203 14.256 14.4077C13.717 12.9588 12.7478 11.7093 11.4782 10.8271C10.2087 9.94494 8.6997 9.47217 7.15375 9.47229ZM10.9389 3.78943C10.9389 4.79445 10.5396 5.7583 9.82899 6.46896C9.11834 7.17962 8.15448 7.57886 7.14946 7.57886C6.14444 7.57886 5.18059 7.17962 4.46993 6.46896C3.75928 5.7583 3.36004 4.79445 3.36004 3.78943C3.36004 2.78441 3.75928 1.82055 4.46993 1.1099C5.18059 0.399242 6.14444 0 7.14946 0C8.15448 0 9.11834 0.399242 9.82899 1.1099C10.5396 1.82055 10.9389 2.78441 10.9389 3.78943Z"
								/>
							</svg>
						</div>
					</router-link>
				</div>
			</div>
			<ul
				v-show="!isAuth"
				class="header__auth"
				data-da=".header__nav,439.98"
			>
				<button
					@click="$emit('openLoginModal')"
					class="header__auth-item _btn-transparent"
				>
					{{ $t('Log in') }}
				</button>
				<button
					@click="$emit('openSignupModal')"
					class="header__auth-item _button-grey"
				>
					{{ $t('Sing up') }}
				</button>
			</ul>
			<div
				class="header__icon-menu icon-menu"
				:class="{ 'menu-open': menuVisible }"
				@click="$emit('toggleMenu')"
			>
				<span></span>
			</div>
		</div>
	</header>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// import CartDropdown from "./CartDropdown.vue";
import { initDynamicAdapt } from '@/utils/dynamic_adapt.js';
import { onClickOutside } from '@vueuse/core';
import { debounce } from 'lodash';

export default {
	name: 'HeaderComponent',
	components: {
		// CartDropdown,
	},
	props: {
		isAuth: { type: Boolean, required: true },
		menuVisible: { type: Boolean, required: true },
		cartContents: { type: Array, required: true },
		isScrolable: { type: Boolean, required: true },
	},
	data() {
		return {
			isScrolled: false,
			showDropdown: false,
			showCartDropdown: false,
			searchTerm: '',
			searchResults: [],
			showSearchResults: false,
			searchIsLoading: false,
			selectedLanguage: null,
			selectedCurrency: null,
			categories: [],
			additionalCategories: [
				//{ name: 'sale', link: '/products/all?sale=true' },
				// { name: 'CONTAINERS', link: '/products/containers' },
				// { name: 'GRAFFITI', link: '/products/graffiti' },
				// { name: 'COLLECTIBLES', link: '/products/collectibles' },
				// { name: 'STICKERS', link: '/products/stickers' },
				// { name: 'PASSES', link: '/products/passes' },
				// { name: 'MUSIC KITS', link: '/products/music-kits' },
				// { name: 'AGENTS', link: '/products/agents' },
				// { name: 'OTHER', link: '/products/other' }
			],
			isHeaderMobile: false,
		};
	},
	computed: {
		...mapState('app', [
			'languages',
			'currencies',
			'currentLanguage',
			'currency',
		]),
		...mapGetters('app', ['currencySymbol']),
		...mapGetters('user', ['userBalance']),
		languageOptions() {
			if (!this.languages) return [];
			return this.languages.map((lang) => ({
				id: lang.id,
				text: lang.title,
			}));
		},
		currencyOptions() {
			return this.currencies.map(({ code }) => ({ id: code, text: code }));
		},
		isDarkHeaderRoute() {
			const path = this.$route.path;
			return path === '/' || path === '/signin' || path === '/singup';
		},
	},
	created() {
		this.debouncedSearchItems = debounce(this.searchItems, 300);
		this.fetchSubcategories();
	},
	watch: {
		currentLanguage(newLang) {
			this.selectedLanguage = newLang;
		},
		searchTerm(newVal) {
			if (!this.$route.query.search || newVal !== this.$route.query.search) {
				this.debouncedSearchItems();
			}
		},
		$route(to) {
			if (
				(to.name === 'ProductListPage' && !to.query.search) ||
				to.name !== 'ProductListPage'
			) {
				this.searchTerm = '';
				this.searchResults = [];
			} else if (to.name === 'ProductListPage' && to.query.search) {
				this.searchTerm = to.query.search;
			}
			this.showSearchResults = false; // Hide results on route change
			this.showDropdown = false;
		},
	},
	mounted() {
		this.selectedLanguage = this.currentLanguage;

		if (this.currency) {
			this.selectedCurrency = this.currency.code;
		}

		if (this.$route.name === 'ProductListPage' && this.$route.query.search) {
			this.searchTerm = this.$route.query.search;
		}
		onClickOutside(this.$refs.dropdownRef, () => {
			this.isOpen = false;
		});

		onClickOutside(this.$refs.searchContainer, () => {
			this.showSearchResults = false;
		});
		window.addEventListener('resize', () => {
			if (window.innerWidth >= 768) {
				this.$emit('closeMenu');
			}
		});
		initDynamicAdapt('max');
		this._onScroll = () => {
			// 1px or more -> add class
			this.isScrolled = window.pageYOffset > 1;
		};
		this._onScroll(); // set initial state
		window.addEventListener('scroll', this._onScroll, { passive: true });

		this.checkMobile();
		this._onResize = () => this.checkMobile();
		this._onOrientation = () => this.checkMobile();

		window.addEventListener('resize', this._onResize, { passive: true });
		window.addEventListener('orientationchange', this._onOrientation);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this._onResize);
		window.removeEventListener('orientationchange', this._onOrientation);
		window.removeEventListener('scroll', this._onScroll);
	},
	methods: {
		sellSkin() {
			if (this.isAuth) {
				//this.$emit('openSellSkinModal');
				this.$router.push('/sell-skin');
			} else {
				this.$router.push('/signin');
			}
		},
		...mapActions('modals', ['openDepositModal']),
		...mapActions('app', ['changeLocale', 'changeCurrency']),
		...mapActions('modals', ['openCartDropdown', 'closeCartDropdown']),
		...mapActions('user', ['fetchUserData']),
		...mapActions('cart', ['fetchCartItems']),
		handleCurrencyChange(e) {
			const value = e?.target ? e.target.value : e;
			this.selectedCurrency = value;
			this.changeCurrency(value);
		},

		handleLanguageChange(e) {
			const value = e?.target ? e.target.value : e;
			this.selectedLanguage = value;
			this.changeLocale(value);
		},
		handleEnterKey() {
			if (this?.searchResults?.length > 0) {
				this.$router.push({
					name: 'ProductListPage',
					params: { itemType: 'all' },
					query: { search: this.searchTerm },
				});
			}
		},
		fetchSubcategories() {
			this.$http
				.get(`${process.env.VUE_APP_API}items/subcategories`)
				.then((response) => {
					this.categories = response.data.payload;
				})
				.catch((error) => {
					console.error('Error fetching subcategories:', error);
				});
		},
		handleCloseCartDropdown() {
			this.closeCartDropdown();
			if (this.$refs.cartDropdown) {
				this.$refs.cartDropdown.hide();
			}
		},
		searchItems() {
			if (this.searchTerm.length > 2) {
				this.searchIsLoading = true;
				this.$http
					.get(`${process.env.VUE_APP_API}items/list`, {
						params: { search: this.searchTerm },
					})
					.then((response) => {
						this.searchResults = response.data.payload;
						this.showSearchResults = true;
					})
					.catch((error) => {
						console.error('Error searching items:', error);
						this.searchResults = [];
						this.showSearchResults = false;
					})
					.finally(() => {
						this.searchIsLoading = false;
					});
			} else {
				this.searchResults = [];
				this.showSearchResults = false;
			}
		},
		removeItemFromCart(item) {
			this.$emit('removeOneFromCart', item);
		},
		toggleCartDropdown() {
			this.showCartDropdown = !this.showCartDropdown;
		},
		openSignIn() {
			this.$emit('openSignIn');
		},
		openSignUp() {
			this.$emit('openSignUp');
		},
		hideDropdown() {
			setTimeout(() => {
				if (!this.$el.querySelector('.mega-menu:hover')) {
					this.showDropdown = false;
				}
			}, 100);
		},
		checkMobile() {
			// UA heuristic (covers most mobile browsers)
			const isMobileUA =
				/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
					navigator.userAgent
				);
			// Viewport fallback (desktop resized, small windows, etc.)
			const isNarrow = window.matchMedia('(max-width: 767.98px)').matches;

			this.isHeaderMobile = isMobileUA || isNarrow;
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================

.header {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	background-color: transparent;
	border-bottom: 1px solid rgba(255, 255, 255, 0.3);
	transition: all 0.3s ease 0s;
	z-index: var(--header-z-index);
	&_scrolled {
		background-color: var(--bg-primary-color);

		.header__inner {
			min-height: 70px;
		}
		@media (max-width: $md4) {
			.header__inner {
				min-height: 50px;
			}
		}
	}
	&_mobile {
		width: 100%;
	}
	&__inner {
		display: flex;
		align-items: center;
		min-height: 64px;
		max-width: 1690px;
		transition: min-height 0.3s ease 0s;
		@include adaptiveValue('gap', 20, 15, 14670, 768, 1);
		min-height: 98px;
		@media (max-width: $md1) {
			min-height: 70px;
		}
		@media (max-width: $md4) {
			min-height: 50px;
			gap: 15px;
		}
	}
	&__logo {
		@include adaptiveValue('min-width', 233, 130, 1470, 768, 1);
		@include adaptiveValue('min-height', 60, 30, 1470, 768, 1);
		position: relative;
		z-index: var(--header-z-index);
		@media (max-width: $md2) {
			margin-right: auto;
		}
	}
	&__nav {
		flex: 1 1 auto;
		min-height: inherit;
	}
	&__options {
		position: relative;
		z-index: var(--header-z-index);
		display: flex;
		@include adaptiveValue('gap', 20, 10, 14670, 768, 1);
		@media (max-width: $md3) {
			justify-content: center;
			order: 2;
		}
		&-wrapper {
		}
	}
	&__user-menu {
		position: relative;
		z-index: var(--header-z-index);
	}
	&__auth {
		position: relative;
		z-index: var(--header-z-index);
		display: flex;
		align-self: center;
		gap: 5px;
		@media (max-width: $md6) {
			order: 1;
			width: 100%;
		}
		&-item {
			position: relative;
			z-index: var(--header-z-index);
			@media (max-width: $md1) {
				min-height: 36px;
				padding: 6px 15px;
			}
			@media (max-width: $md4) {
				white-space: nowrap;
			}
			@media (max-width: $md5) {
				flex: 0 1 50%;
			}
		}
	}
	&__icon-menu {
		position: relative;
		z-index: var(--header-z-index);
		@media (min-width: $md2) {
			@include hide-item;
		}
	}
}

.nav {
	display: flex;
	@media (max-width: $md2) {
		flex-direction: column;
		justify-content: flex-start;
	}
	@media (max-width: $md2) {
		position: fixed;
		top: 70px;
		left: -100%;
		width: 100%;
		height: calc(100% - 70px);
		min-height: fit-content;
		z-index: var(--menu-z-index);
		padding: 25px 10px 30px;
		overflow-y: auto;
		transition: left 0.3s ease 0s;
		background-color: var(--bg-primary-color);
		border-top: 1px solid var(--primary-color);
		&::before {
			content: '';
			position: fixed;
			z-index: var(--header-overlay-z-index);
			top: 0;
			left: -100%;
			width: 100%;
			height: 70px;
			background-color: var(--bg-primary-color);
			transition: left 0.3s ease 0s;
		}
		&.menu-open {
			left: 0;
			&::before {
				left: 0;
			}
		}
	}
	@media (max-width: $md4) {
		top: 50px;
		height: calc(100% - 50px);
		&::before {
			height: 50px;
		}
	}
	&__list {
		min-height: inherit;
		@media (min-width: $md2) {
			display: flex;
		}
		@media (max-width: $md2) {
			order: 2;
		}
	}
	&__item {
		min-height: inherit;
		@media (max-width: $md2) {
			margin: 0 -10px;
		}
	}
	&__link {
		padding-top: 8px;
		padding-bottom: 8px;
		@include adaptiveValue('padding-right', 40, 10, 1470, 768, 1);
		@include adaptiveValue('padding-left', 40, 10, 1470, 768, 1);
		min-height: inherit;
		display: flex;
		align-items: center;
		cursor: pointer;
		pointer-events: auto;
		font-weight: 500;
		font-size: 16px;
		line-height: 1.5;
		color: var(--primary-color);
		border-bottom: 2px solid transparent;
		transition: border 0.3s ease 0s;
		@media (any-hover: hover) {
			&:hover {
				border-bottom: 2px solid var(--primary-color);
			}
		}
		&_active {
			pointer-events: none;
			border-bottom: 2px solid var(--hint-color);
		}
	}
}

.wallet {
	display: flex;
	display: flex;
	align-items: center;
	border-radius: var(--border-radius-primary);
	@include adaptiveValue('padding', 15, 10, 1470, 768, 1);
	border: 1px solid var(--secondary-color);
	gap: 20px;
	transition: border 0.3s ease 0s;
	max-height: 60px;
	min-height: 60px;
	height: 100%;
	pointer-events: auto;
	@media (any-hover: hover) {
		&:hover {
			border: 1px solid var(--hint-color);
		}
	}
	@media (max-width: $md4) {
		width: 100%;
		justify-content: center;
	}
	&_active {
		pointer-events: none;
		border: 1px solid var(--hint-color);
		.wallet__button {
			pointer-events: none;
		}
	}
	&.router-link-active {
	}
	&__numbers {
	}
	&__top {
		display: flex;
		align-items: center;
		gap: 4px;
	}
	&__coin-number {
		font-size: 16px;
		line-height: 1.5;
	}
	&__coin-icon {
		flex: 0 0 14px;
		min-width: 14px;
		height: 14px;
	}
	&__bottom {
		display: flex;
		align-items: center;
		gap: 4px;
	}
	&__real-number,
	&__real-symbol {
		font-size: 12px;
		line-height: 1.5;
		color: var(--secondary-color);
	}
	&__button {
		align-self: center;
	}
}

.user-menu {
	min-height: inherit;
	display: flex;
	&__wallet {
		align-self: center;
	}
	&__actions {
		display: flex;
		min-height: inherit;
	}
	&__cart,
	&__profile {
		@include adaptiveValue('padding-left', 20, 10, 1470, 768, 1);
		@include adaptiveValue('padding-right', 20, 10, 1470, 768, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 100%;
		&-icon {
			min-width: 24px;
			height: 24px;
			svg {
				path {
					stroke: var(--primary-color);
					transition: stroke 0.3s ease 0s;
				}
			}
		}
		&-amount {
			transform: translateY(-50%);
			color: var(--primary-color);
			max-width: 28px;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
	}
	&__cart {
		background-color: transparent;
		@media (any-hover: hover) {
			&:hover {
				svg {
					path {
						stroke: var(--hint-color);
					}
				}
			}
		}
	}
	&__profile {
		position: relative;
		@media (any-hover: hover) {
			&:hover {
				&::before {
					opacity: 1;
				}
			}
		}
		&::before {
			content: '';
			z-index: -1;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: var(--hint-color);
			border-radius: 50%;
			width: 44px;
			height: 44px;
			opacity: 0;
			transition: opacity 0.3s ease 0s;
		}
		&-icon {
			height: 27px;
		}
	}
}

// burger icon
.icon-menu {
	display: none;
	@media (max-width: $md2) {
		display: block;
		position: relative;
		width: 30px;
		height: 18px;
		cursor: pointer;
		z-index: 12;
		span,
		&::before,
		&::after {
			content: '';
			transition: all 0.3s ease 0s;
			right: 0;
			position: absolute;
			width: 100%;
			height: 2px;
			background-color: var(--primary-color);
		}
		&::before {
			top: 0;
		}
		&::after {
			bottom: 0;
		}
		span {
			top: calc(50% - 1px);
		}
		&.menu-open {
			span {
				width: 0;
			}
			&::before,
			&::after {
			}
			&::before {
				top: calc(50% - 1px);
				transform: rotate(-45deg);
			}
			&::after {
				bottom: calc(50% - 1px);
				transform: rotate(45deg);
			}
		}
	}
}
</style>
